import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia

export { useAuthStore } from './auth.store'
export { useDashboardStore } from './dashboard.store'
export { usePermissionsStore } from './permissions.store'
export { usePageBuilderUxStore } from './page-builder-ux.store'
export { useSidebarStore } from './sidebar.store'
export { useThemeWorkspaceStore } from './theme-workspace.store'
export { useUiStore } from './ui.store'
